<script setup>
import { usePlatform } from '@/composables/usePlatform.js';
import { computed, watch } from 'vue';

const props = defineProps({
    platform: {
        type: String,
        required: false,
        default: null,
    },
});
const { currentPlatform } = usePlatform();
const platformCode = computed(() => props.platform || currentPlatform.value?.code);
</script>
<template>
    <svg
        v-bind="$attrs"
        v-if="platformCode === 'FC'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 320"
        class="block aspect-square max-h-full max-w-full object-contain"
    >
        <path
            id="Path_64"
            data-name="Path 64"
            d="M344.661.226H74.782Q52.011,2.8,49.776,28.39l-.12,263.665c1.461,17.061,9.792,26.385,24.872,28.171H344.661c15.085-1.785,23.411-11.116,24.875-28.171l.12-263.665Q367.449,2.759,344.661.226Z"
            transform="translate(-49.656 -0.226)"
            fill="#3f3456"
            fill-rule="evenodd"
        />
        <g id="Group_13" data-name="Group 13" transform="translate(42 92.001)">
            <path
                id="Path_21"
                data-name="Path 21"
                d="M0,134.723V5.029H102.993V35.771H37.531V60.062H98.919V90.076H37.531v44.646Z"
                transform="translate(0 -1.868)"
                fill="#fff"
            />
            <path
                id="Path_22"
                data-name="Path 22"
                d="M299.344,115.815c-15.173,14.451-33.563,20.2-53.909,20.2-52.729,0-73.263-32.062-73.451-67.334C171.8,35.4,194.984,0,245.435,0a74.189,74.189,0,0,1,28.173,5.252A72.176,72.176,0,0,1,297.416,20.72L274.011,42.966a39.692,39.692,0,0,0-13.1-8.449,40.788,40.788,0,0,0-15.475-2.842c-25.9,0-36.055,20.381-35.867,37.24s9.409,35.945,35.867,35.945a47.285,47.285,0,0,0,31.66-13.154Z"
                transform="translate(-63.863 0)"
                fill="#fff"
            />
        </g>
    </svg>

    <svg v-bind="$attrs" v-if="platformCode === 'PH'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320">
        <g id="Group_14" data-name="Group 14" transform="translate(-975 -514)">
            <path
                id="Path_62"
                data-name="Path 62"
                d="M344.661.226H74.782Q52.011,2.8,49.776,28.39l-.12,263.665c1.461,17.061,9.792,26.385,24.872,28.171H344.661c15.085-1.785,23.411-11.116,24.875-28.171l.12-263.665Q367.449,2.759,344.661.226Z"
                transform="translate(925.344 513.774)"
                fill="#ff9000"
                fill-rule="evenodd"
            />
            <path
                id="Path_63"
                data-name="Path 63"
                d="M32.423,56.49V13.69H56.814a65.714,65.714,0,0,1,10.4.8,24.185,24.185,0,0,1,8.8,3.1,16.886,16.886,0,0,1,6.1,6.5q2.3,4.2,2.3,11t-2.3,11a16.886,16.886,0,0,1-6.1,6.5,24.185,24.185,0,0,1-8.8,3.1,65.713,65.713,0,0,1-10.4.8ZM1.035-10.71v142.8H32.423V80.89H65.411q13.395,0,22.791-3.9A42.64,42.64,0,0,0,103.5,66.69a39.438,39.438,0,0,0,8.6-14.7,54.573,54.573,0,0,0,0-33.9,39.571,39.571,0,0,0-8.6-14.6A42.641,42.641,0,0,0,88.2-6.81q-9.4-3.9-22.791-3.9Zm129.351,0v142.8h31.388V70.49h57.778v61.6h31.388V-10.71H219.553v54.8H161.775v-54.8Z"
                transform="translate(1008.965 613.743)"
            />
        </g>
    </svg>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128 128"
        class="h-16 rounded-full shadow-2xl shadow-black/10"
        v-if="platformCode === 'MH'"
    >
        <defs>
            <clipPath id="a"><path fill="none" d="M0 0h128v128H0z" /></clipPath>
        </defs>
        <g clip-path="url(#a)">
            <path d="M64 128a64 64 0 1 1 64-64 64 64 0 0 1-64 64" fill="#eeed" />
            <path d="M63.771 124a60 60 0 1 1 60-60 60 60 0 0 1-60 60" fill="#eee0" />
            <path d="M63.771 120a56 56 0 1 1 56-56 56 56 0 0 1-56 56" fill="#8878b5" />
            <path
                d="M72.144 81.629H55.2A6.01 6.01 0 0 0 49.447 86l-1.059 3.646a6.01 6.01 0 0 1-5.752 4.368H32.5a6.078 6.078 0 0 1-5.613-8.23l23.225-62.825a6 6 0 0 1 5.613-3.949h16.558a6 6 0 0 1 5.611 3.947l23.218 62.823a6.078 6.078 0 0 1-5.612 8.23H84.731A6.006 6.006 0 0 1 79 89.686l-1.112-3.731a6.007 6.007 0 0 0-5.739-4.326"
                fill="#eee"
            />
            <path
                d="m73.554 61.08-.007-.022c-2.891-9.426-16.241-9.406-19.1.028v.014a9.993 9.993 0 1 0 19.116-.02"
                fill="#8878b5"
            />
            <path
                d="M53.2 109.6a1.7 1.7 0 0 1-1.7-1.7v-8.846a1.7 1.7 0 1 1 3.4 0v8.846a1.7 1.7 0 0 1-1.7 1.7"
                fill="#eee"
            />
            <path
                d="M57.52 104.921a1.7 1.7 0 0 1-1.7-1.7v-4.167a1.7 1.7 0 1 1 3.4 0v4.166a1.7 1.7 0 0 1-1.7 1.7"
                fill="#eee"
            />
            <path
                d="M61.84 109.6a1.7 1.7 0 0 1-1.7-1.7v-8.846a1.7 1.7 0 1 1 3.4 0v8.846a1.7 1.7 0 0 1-1.7 1.7"
                fill="#eee"
            />
            <path
                d="M66.16 109.6a1.7 1.7 0 0 1-1.7-1.7v-8.846a1.7 1.7 0 1 1 3.4 0v8.846a1.7 1.7 0 0 1-1.7 1.7"
                fill="#eee"
            />
            <path
                d="M70.48 105.815a1.7 1.7 0 0 1-1.7-1.7v-1.275a1.7 1.7 0 0 1 3.4 0v1.275a1.7 1.7 0 0 1-1.7 1.7"
                fill="#eee"
            />
            <path
                d="M74.8 109.6a1.7 1.7 0 0 1-1.7-1.7v-8.846a1.7 1.7 0 1 1 3.4 0v8.846a1.7 1.7 0 0 1-1.7 1.7"
                fill="#eee"
            />
        </g>
    </svg>
</template>
